var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c(
          "b-row",
          { staticClass: "mt-4 neu-cards-quiz-ctn history-options-block" },
          _vm._l(_vm.blocks, function(block) {
            return _c("clinic-history-quiz-block", {
              key: block.id,
              attrs: {
                id: block.id,
                title: block.title,
                action: block.action,
                iconSize: block.iconSize,
                blockIdSelected: _vm.blockIdSelected,
                completed: _vm.isCompleted(block.id)
              }
            })
          }),
          1
        ),
        _vm._v(" "),
        _vm._l(_vm.questionsAndAnswers, function(item) {
          return _c("clinic-history-quiz-form", {
            key: item.id,
            attrs: {
              questionId: item.id,
              question: item.question,
              answers: item.answers,
              answerVarName: item.answerVarName,
              healthVarValue: item.healthVarValue,
              answersSelected: item.answersSelected,
              inputType: item.inputType,
              quizAnswersColumnsAnchor: _vm.getQuizAnswersColumnsAnchor(
                item.answerVarName
              ),
              dontKnowAnswerTitle: _vm.dontKnowAnswerTitle(item),
              showDontKnowAnswer: _vm.showDontKnowAnswer(item),
              isCompleted: _vm.currentBlockIsCompleted
            },
            on: {
              elementSelected: function($event) {
                return _vm.processElementSelected(item, $event)
              },
              inputSelected: function($event) {
                item.healthVarValue = $event
                item.answersSelected = []
              }
            }
          })
        }),
        _vm._v(" "),
        _vm.blockIdSelected
          ? _c(
              "div",
              { staticClass: "save-quiz-btn my-4" },
              [
                !_vm.readOnly
                  ? _c("base-button", { on: { click: _vm.saveQuizData } }, [
                      _vm._v(_vm._s(_vm.saveQuizBtnText))
                    ])
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("base-dialog", {
          attrs: {
            content: _vm.$t("quizDialog.completeMedicalEvaluation"),
            okBtnText: _vm.$t("yes"),
            cancelBtnText: _vm.$t("no"),
            okFn: function() {
              _vm.showDialogMedicalEvaluation = false
              _vm.blockIdSelected = _vm.nextBlock[_vm.blockIdSelected]
              _vm.loadClinicBlock(true)
            },
            cancelFn: function() {
              _vm.showDialogMedicalEvaluation = false
              _vm.quizCompleted()
            }
          },
          model: {
            value: _vm.showDialogMedicalEvaluation,
            callback: function($$v) {
              _vm.showDialogMedicalEvaluation = $$v
            },
            expression: "showDialogMedicalEvaluation"
          }
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-546e481b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-546e481b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/clinicHistory/quiz/ClinicHistoryQuiz.vue
// module id = 3063
// module chunks = 32 63